import BaseService from 'services/baseService';
import { REACT_APP_BASE_URL } from 'shared/config/config';
import { serialize } from 'shared/helpers';

const getBrandingDetailsUrl = '/on-boarding/branding-details';
const getUserIpUrl = 'https://api.ipify.org/?format=json';
const getCityCountryUrl = 'https://api.ipbase.com/v1/json/';
const loginUrl = '/v2/login';
const registerUrl = '/getstarted-v2';
const registerWhatsappPlgUrl = 'wa-accelerator/get-started';
const resendOtpUrl = '/resend-otp';
const updateVerificationTypeUrl = '/verification/update';
const forgotPasswordUrl = '/v2/input_email';
const resetPasswordUrl = '/reset-password';
const verifyCodeUrl = '/validate/verify-code';
const verifyCustomerUrl = '/verify-account';
const genericProxyRequestUrl = '/v2/genericProxyRequest/';
const loginRedirectUrl = '/v2/redirect/login';
const send2faOtp = '/v2/generate/2fa-otp';
const validate2faOtp = '/v2/validate/2fa-otp';
const validate2faTotp = `${REACT_APP_BASE_URL}/global/v1/validate-2fa-totp`;
const setup2faTotp = `${REACT_APP_BASE_URL}/global/v1/setup-2fa-totp`;
const mfaEnrollmentEmailOtpSend = '/v2/mfa-enrollment/email-otp/send';
const mfaEnrollmentEmailOtpValidate = '/v2/mfa-enrollment/email-otp/validate';
const mfaEnrollmentTotpSetup = '/v2/mfa-enrollment/totp/setup';
const mfaEnrollmentComplete = '/v2/mfa-enrollment/complete';

const getBrandingDetailsApi = new BaseService(getBrandingDetailsUrl);
const loginAPi = new BaseService(loginUrl);
const loginRedirectApi = new BaseService(loginRedirectUrl);
const mergedRegistrationSecondStep = '/merged-registration/choose-product-vertical';
const registerApi = new BaseService(registerUrl);
const registerWhatsappPlgApi = new BaseService(registerWhatsappPlgUrl);
const resendOtpApi = new BaseService(resendOtpUrl);
const updateVerificationTypeApi = new BaseService(updateVerificationTypeUrl);
const forgotPasswordApi = new BaseService(forgotPasswordUrl);
const resetPasswordApi = new BaseService(resetPasswordUrl);
const verifyCodeApi = new BaseService(verifyCodeUrl);
const verifyCustomerApi = new BaseService(verifyCustomerUrl);
const genericProxyRequestApi = new BaseService(genericProxyRequestUrl);
const send2faOtpApi = new BaseService(send2faOtp);
const validate2faOtpApi = new BaseService(validate2faOtp);
const validate2faTotpApi = new BaseService(validate2faTotp);
const setup2faTotpApi = new BaseService(setup2faTotp);
const mfaEnrollmentEmailOtpSendApi = new BaseService(mfaEnrollmentEmailOtpSend);
const mfaEnrollmentEmailOtpValidateApi = new BaseService(mfaEnrollmentEmailOtpValidate);
const mfaEnrollmentTotpSetupApi = new BaseService(mfaEnrollmentTotpSetup);
const mfaEnrollmentCompleteApi = new BaseService(mfaEnrollmentComplete);
const mergedRegistrationSecondStepApi = new BaseService(mergedRegistrationSecondStep);

export const API = {
	getBrandingDetails() {
		return getBrandingDetailsApi.getRequest(window.location.search);
	},
	getUserIp() {
		return fetch(getUserIpUrl);
	},
	getCityCountry() {
		return fetch(getCityCountryUrl);
	},
	login(data) {
		return loginAPi.postRequest(data);
	},
	loginRedirect(data) {
		const params = {
			config: data,
		};

		return loginRedirectApi.getRequest(serialize(params, '?'));
	},
	register(data, params) {
		return registerApi.postRequest(data, serialize(params, '?'));
	},
	registerWhatsappPlg(data, params) {
		return registerWhatsappPlgApi.postRequest(data, serialize(params, '?'));
	},
	resendOtp(email) {
		return resendOtpApi.postRequest({ email, moduleName: '' });
	},
	updateRegistrationVerificationType(data) {
		return updateVerificationTypeApi.postRequest(data);
	},
	forgotPassword(data) {
		return forgotPasswordApi.postRequest(data);
	},
	resetPassword(data) {
		return resetPasswordApi.postRequest(data);
	},
	updateProductVertical(data) {
		const params = {
			targetApi: 'updateProductVertical',
		};

		return genericProxyRequestApi.putRequest(data, serialize(params, '?'));
	},
	validateVerificationToken(token) {
		const params = {
			code: token,
		};

		return verifyCodeApi.getRequest(serialize(params, '?'));
	},
	verifyCustomer(token) {
		const params = {
			token,
			isPortalV2: true,
		};

		return verifyCustomerApi.getRequest(serialize(params, '?'));
	},
	send2faOtpMail(email, isRecovery = false) {
		const params = {
			email,
			isRecovery,
		};

		return send2faOtpApi.getRequest(serialize(params, '?'));
	},
	validate2faOtp(data, isRecovery = false) {
		const params = {
			...data,
			isRecovery,
		};

		return validate2faOtpApi.getRequest(serialize(params, '?'));
	},
	validate2faTotp(data) {
		return validate2faTotpApi.postRequestWithParams({}, data);
	},
	setup2faTotp(email) {
		return setup2faTotpApi.postRequestWithParams({}, { email });
	},
	startMfaEnrollment(method) {
		return mfaEnrollmentEmailOtpSendApi.postRequest({ method });
	},
	validateMfaEnrollmentEmailOtp(otp) {
		return mfaEnrollmentEmailOtpValidateApi.postRequest({ otp });
	},
	setupMfaEnrollmentTotp() {
		return mfaEnrollmentTotpSetupApi.postRequest({});
	},
	completeMfaEnrollment(payload) {
		return mfaEnrollmentCompleteApi.postRequest(payload);
	},
	createSalesforceObject(data) {
		const params = {
			targetApi: 'createSalesforceObject',
		};

		return genericProxyRequestApi.postRequest(data, serialize(params, '?'));
	},
	updateSalesforceObject(data, email) {
		const params = {
			targetApi: 'updateSalesforceObject',
			email,
		};

		return genericProxyRequestApi.putRequest(data, serialize(params, '?'));
	},
	mergedRegistrationSecondStep(data, params) {
		return mergedRegistrationSecondStepApi.postRequest(data, serialize(params, '?'));
	},
};
